import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const JamforElavtalTest = lazy(() => import("@/pages/elavtal/JamforElavtalTest"));

export const Route = createFileRoute("/elavtal/jamfor-test")({
  head: () => ({
    meta: [
      { title: "Testvy jämför elavtal » Elmarknad.se" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      { name: "description", content: "Intern testvy av jämförelsesidan." },
      { property: "og:title", content: "Testvy jämför elavtal" },
      { property: "og:description", content: "Intern testvy av jämförelsesidan." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <JamforElavtalTest />,
});
